<template>
  <!--行政处罚-->
  <TableView
    :columns="columns"
    :data="data"
    :pagination="false"
    :loading="loading"
    :bordered="bordered"
    :scroll="scroll"
    :rowKey="rowKey"
  ></TableView>
</template>
<script>
import { TableView } from '@/lxfintech-fe-components'
export default {
  props: ['data'],
  components: { TableView },
  data() {
    return {
      rowKey: 'id',
      scroll: { x: 1300 },
      columns: [
        {
          title: '序号',
          width: 100,
          dataIndex: 'order',
          key: 'order',
          fixed: 'left',
          customRender: (text, record, index) => {
            return index + 1
          },
        },
        {
          title: '决定书文号',
          dataIndex: 'documentNumber',
          key: 'documentNumber',
        },
        {
          title: '违法行为类型',
          dataIndex: 'type',
          key: 'type',
        },
        {
          title: '违法事实',
          dataIndex: 'illegalFacts',
          key: 'illegalFacts',
        },
        {
          title: '行政处罚内容',
          dataIndex: 'content',
          key: 'content',
        },
        {
          title: '决定机关',
          dataIndex: 'office',
          key: 'office',
        },
        {
          title: '处罚决定日期',
          dataIndex: 'decisionDate',
          key: 'decisionDate',
        },
        {
          title: '公示日期',
          dataIndex: 'publicityDate',
          key: 'publicityDate',
        },
      ],
      loading: false,
      bordered: true,
    }
  },
  methods: {},
}
</script>
